import Api from '../../services';

export const tokenizeCard = (data) => {
  return (dispatch) => {
    return Api.cards.tokenizeCard(data).then((response) => {
      dispatch({
        type: 'TOKENIZE_CARD',
        data: response,
      });
      return response;
    });
  };
};

export const getCards = () => {
  return (dispatch) => {
    return Api.cards.getCards().then((response) => {
      dispatch({
        type: 'GET_CARDS',
        data: response,
      });
      return response;
    });
  };
};

export const deleteCard = (cardId) => {
  return (dispatch) => {
    return Api.cards.deleteCard(cardId).then((response) => {
      dispatch({
        type: 'DELETE_CARD',
        data: response,
      });
      return response;
    });
  };
};

export const updateCard = (cardId, data) => {
  return (dispatch) => {
    return Api.cards.updateCard(cardId, data).then((response) => {
      dispatch({
        type: 'UPDATE_CARD',
        data: response,
      });
      return response;
    });
  };
};
